export default __webpack_public_path__ + "static/media/instagram.4cd35c70.svg";